import axios from "axios"
import { authHeader } from "../../utils"
import { GETTING_STAFF, GET_STAFF, ONBOARDING_STAFF, ONBOARD_STAFF, RESENDING_INVITATION, RESEND_INVITATION, REVOKING_INVITATION, REVOKE_INVITATION, STAFF_ERROR, UPDATING_STAFF, UPDATED_STAFF } from "../types"

export const onboardStaff = (staffPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: ONBOARDING_STAFF,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/staff`, staffPayload, { headers })
        
        dispatch({
            type: ONBOARD_STAFF,
            payload: response.data.data
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: STAFF_ERROR,
            // payload: error.response.data
            error
        })
    }
}

export const resendInvitation = (invitationCode) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: RESENDING_INVITATION,
            payload: invitationCode
        })

        const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/auth/invitations/resend/${invitationCode}`, 
            {frontendUrl: window.location.origin},
            { headers }
        )
        
        dispatch({
            type: RESEND_INVITATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: STAFF_ERROR,
            error
        })
    }
}

export const revokeInvitation = (invitationCode) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: REVOKING_INVITATION,
            payload: invitationCode
        })

        const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/auth/invitations/revoke/${invitationCode}`, 
            { headers }
        )
        
        dispatch({
            type: REVOKE_INVITATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: STAFF_ERROR,
            error
        })
    }
}

export const clearResentInvitation = (invitationCode) => async (dispatch) => {       
    dispatch({
        type: RESEND_INVITATION,
        payload: null
    })
}

export const fetchStaff= (filters, page, perPage) => async dispatch => {    
    try{
        const headers = authHeader()

        let url = `${process.env.REACT_APP_BASE_URL}/staff?expand=designations,department,userProfile,invitation,departmentHistory.department,designationHistory.designation`
        if(filters && filters !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filters}`
        }

        if((page || page===0) && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if((perPage || perPage===0) && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_STAFF,
            payload: true
        })

        const response = await axios.get(`${url}`, { headers })

        dispatch( {
            type: GET_STAFF,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: STAFF_ERROR,
            // payload: error.response.data,
            error
        })
    }
}

export const clearOnboardedStaff = () => async dispatch => {
    dispatch({
        type: ONBOARD_STAFF,
        payload: null
    })
}

export const updateStaff = (staffId, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_STAFF,
            payload: true
        })

        const response = await axios.patch(
            `${process.env.REACT_APP_BASE_URL}/staff/${staffId}`, 
            payload,
            { headers }
        )
        
        dispatch({
            type: UPDATED_STAFF,
            payload: response.data.data
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: STAFF_ERROR,
            error
        })
    }
}

// export const getWalletDetails = (walletId) => async dispatch => {    
//     try{
//         const headers = authHeader()
//         dispatch({
//             type: GETTING_WALLET_DETAILS,
//             payload: true
//         })
//         const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/wallets/${walletId}?expand=custodian`, { headers })
//         dispatch( {
//             type: GET_WALLET_DETAILS,
//             payload: response.data.data
//         })
//     }
//     catch(error){
//         dispatch( {
//             type: WALLET_DETAILS_ERROR,
//             error
//             // payload: error.response.data,
//         })
//     }
// }